import { render, staticRenderFns } from "./WabaSupsisDisabledUpdate.vue?vue&type=template&id=2eb60519&scoped=true"
import script from "./WabaSupsisDisabledUpdate.vue?vue&type=script&lang=js"
export * from "./WabaSupsisDisabledUpdate.vue?vue&type=script&lang=js"
import style0 from "./WabaSupsisDisabledUpdate.vue?vue&type=style&index=0&id=2eb60519&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb60519",
  null
  
)

export default component.exports